<template>
  <div class="bg pr part8">
    <div class="footer">
      <div class="flt">
        <img src="../assets/images/page7/level.png" alt="" />
      </div>
      <div class="frt">
        <div class="us">
          <a href="https://www.xiaoma.com.tw/privacy.html">隐私政策</a>
          <a href="https://www.xiaoma.com.tw/terms.html">服务条款</a>
          <a href="javaScript:void(0)" @click="attention()">注意事项</a>
          <!-- @click="beCareful = true" -->
        </div>
        <div class="conpanyMs">
          <p class="ms">
            *本軟體因涉及暴力，依遊戲軟體分級管理辯法分類為輔12歲級
          </p>
          <p class="ms">*遊戲內提供購買虛擬遊戲幣、物品等付費服務</p>
          <p class="ms">*請注意遊戲時間，避免沉迷</p>
        </div>
      </div>
    </div>
    <!-- <transition name="alert">
      <Alert v-if="beCareful" @close="beCareful = false">
        <div class="be-careful"></div>
      </Alert>
    </transition> -->
  </div>
</template>

<script>
export default {
  data() {
    return {
      // beCareful: false,
    };
  },
  methods: {
    attention() {
      this.$bus.$emit(
        "tips",
        `1.活動時間：2023年5月5日至遊戲上線前結束
            2.活動期間內完成預約、FB按讚、神劍認主活動獲得的禮包碼，可在「獎勵記錄」中查看，遊戲上市後即可兌換；商店預定獎勵將在官方FB公佈
            3.活動期間內，玩家預約人數達成即可解鎖對應里程碑獎勵，預約里程碑禮包也將在官方FB同步公開
            4.實體獎勵中獎名單將在遊戲上線後10個工作日內於《大仙尊：修仙問情》官方粉絲專頁公示；依據稅法規定，中獎贈品或獎金均為所得稅，達1000元以上需申報所得稅，達到20001（含）元以上還需預先繳納機會中獎稅10%。
            5.如使用外掛等不正常方式參加本活動，官方將有權取消用戶參與及兌換資格。
            6.《大仙尊：修仙問情》官方保留對活動的修改權及最終解釋權。`,
        "attention"
      );
    },
  },
};
</script>

<style lang="less" scoped>
.part8 {
  width: 100%;
  height: 4.75rem;
  text-align: center;

  .footer {
    width: 80%;
    display: flex;
    align-items: center;
    justify-content: center;
    margin: 0 auto;
    gap: 0.3rem;
    font-family: medium;
    .flt {
      width: 0.76rem;

      img {
        width: 100%;
        height: 100%;
      }
    }
    .frt {
      font-size: 0.2rem;
      .conpanyMs {
        color: #E4F4FF;
        text-align: left;
        line-height: 0.4rem;
        width: 100%;
      }
      .us {
        display: flex;
        justify-content: start;
        align-items: center;
        gap: 0.5rem;
        margin-bottom: 0.2rem;
        padding-left: 0.4rem;
      }
      a {
        color: #E4F4FF;
        font-weight: 500;
        height: 0.35rem;
        line-height: 0.35rem;
        font-family: Medium;
        // margin-right: 0.5rem;
        &::after {
          content: "";
          height: 0.03rem;
          background: #E4F4FF;
          width: 100%;
          display: block;
        }
        &:hover {
          text-decoration: none;
        }
      }
    }
  }
}
</style>